export default __webpack_public_path__ + "static/media/logo.0ae471f3.png";